export const empiTheme = {
  colors: {
    background: "#F5F5F7",
    surface: "#FFFFFF",
    text: "#1D1D1F",
    textSecondary: "#6E6E73",
    border: "#E5E5E7",
    primary: "#383535",
  },

  layout: {
    maxWidth: 1100,
    sectionPadding: "80px 20px",
  },

  radius: {
    card: 18,
    button: 14,
  },

  shadow: {
    card: "0 4px 12px rgba(0,0,0,0.03)",
  },

  typography: {
    eyebrow: {
      fontSize: 12,
      letterSpacing: 1.2,
      textTransform: "uppercase",
    },

    h1: {
      fontSize: 52,
      lineHeight: 1.05,
    },

    h2: {
      fontSize: 34,
      lineHeight: 1.15,
    },

    body: {
      fontSize: 18,
      lineHeight: 1.65,
    },

    small: {
      fontSize: 14,
      lineHeight: 1.55,
    },

    components: {
      primaryButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px 16px",
        borderRadius: 14,
        background: "linear-gradient(180deg, #F8C9B6 0%, #F4A98A 100%)",
        color: "#3A2A24",
        textDecoration: "none",
        fontWeight: 700,
        border: "1px solid #F2B79D",
        boxShadow: "0 5px 12px rgba(244, 169, 138, 0.24)",
        cursor: "pointer",
      },
    },
  },
};
